import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'json-editor',
  templateUrl: './json-editor.component.html',
  styleUrls: ['./json-editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => JsonEditorComponent),
      multi: true,
    },
  ],
})
export class JsonEditorComponent implements ControlValueAccessor {
  onChange: (_: any) => void = (_: any) => {};

  str: any;
  value: any;
  error: any;

  constructor() {}
  writeValue(obj: any): void {
    this.str = JSON.stringify(obj, null, 2);
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {}
  setDisabledState?(isDisabled: boolean): void {}

  onBlur() {
    if (this.value) {
      this.str = JSON.stringify(this.value, null, 2);
      this.onChange(this.value);
    }
  }

  updateChanges() {
    this.error = null;

    if (this.str) {
      try {
        this.value = JSON.parse(this.str);
      } catch (err) {
        this.error = err;
        this.value = null;
      }
    } else {
      this.value = null;
    }
  }
}
